import type {
  Category,
  EventId,
  EventSubtask,
  HabitId,
  PlanEvent,
  Priority,
  SubtaskId,
  Subtask,
  Task,
  TaskId,
} from "./index";

/** Polyfill crypto.randomUUID pour les WebView Android qui ne le supportent pas */
function uuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback: génération via crypto.getRandomValues
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function createTaskId(): TaskId {
  return uuid() as TaskId;
}

export function createEventId(): EventId {
  return uuid() as EventId;
}

export function createSubtaskId(): SubtaskId {
  return uuid() as SubtaskId;
}

export function createHabitId(): HabitId {
  return uuid() as HabitId;
}

export function createTask(
  title: string,
  category: Category,
  dueDate: string | null = null,
  eventId: EventId | null = null,
  priority: Priority = "normal",
): Task {
  return {
    id: createTaskId(),
    title,
    category,
    status: "todo",
    priority,
    createdAt: Date.now(),
    dueDate,
    notes: "",
    tags: [],
    subtasks: [],
    archived: false,
    completedAt: null,
    recurrence: null,
    eventId,
    reminderMinutes: null,
    reminderTime: null,
    reminderType: null,
  };
}

export function createSubtask(title: string): Subtask {
  return { id: createSubtaskId(), title, done: false };
}

export function createEventSubtask(
  title: string,
  afterPriority = 0,
): EventSubtask {
  return { id: createSubtaskId(), title, done: false, priority: afterPriority + 1 };
}

export function createPlanEvent(
  title: string,
  category: Category,
  date: string,
  startTime: string,
  endTime: string,
): PlanEvent {
  return {
    id: createEventId(),
    title,
    category,
    date,
    startTime,
    endTime,
    createdAt: Date.now(),
    description: "",
    notes: "",
    tags: [],
    recurrence: null,
    reminderMinutes: null,
    reminderTime: null,
    reminderType: null,
  };
}
